import { toast } from "react-toastify";
import { useLogout } from "utils/hooks";

const useSendCode = () => {
  const { logOut } = useLogout();

  const sendCode = async (email: string) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_REST_API_URL}/2fa/send-code`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            permissionKey: "send_2fa_code",
          },
          body: JSON.stringify({ email }),
        }
      );

      const resData = await res.json();

      if (!res.ok) {
        if (resData.message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else if (resData.message.includes("GNRC_6024")) {
          toast.warn("Code already sent, please check your email");
        } else {
          toast.error(resData.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    sendCode,
  };
};

export default useSendCode;
